import React from "react";
import {
	Button,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@material-ui/core";

import {makeMessages} from "../../utils/makeMessages";
import { Dialog } from "../Dialogs/Dialog";
import { GdprContentSK } from "./GdprContentSK";
import { GdprContentEN } from "./GdprContentEN";



export interface GdprModalProps {
	open: boolean,
	onClose: () => void,
}


export const GdprDialog = (props: GdprModalProps) => {
	const { open, onClose } = props;
	const m = useMessages();
	
	return (
		<Dialog
			maxWidth="sm"
			open={open}
			onClose={onClose}
			scroll="body"
		>
			<DialogTitle>{m.title}</DialogTitle>
			<DialogContent>
				<DialogContentText component="div">
					{m.content}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>{m.close}</Button>
			</DialogActions>
		</Dialog>
	);
}

const useMessages = makeMessages({
	title: {
		sk: 'Informácie o spravovaní a ochrane vašich osobných údajov',
		en: 'Privacy and Personal Data Protection',
	},
	content: {
		sk: <GdprContentSK />,
		en: <GdprContentEN />,
	},
	close: {
		sk: 'Zavrieť',
		en: 'Close',
	}
});
